// @flow
import type { PublicPage as ApiPublicPage } from 'api/website';
import type { Action } from '../actions/pages';

export type PageStates = 'UNFETCHED' | 'SUCCESS' | 'NOT_FOUND' | 'FETCHING';

export type Page = {
  ...$Exact<ApiPublicPage>
};

export type State = {
  byUrl: {
    [string]: {
      ...Page,
      state: 'SUCCESS' | 'NOT_FOUND' | 'FETCHING'
    }
  }
};

const defaultState = { byUrl: {} };

export default function pages(state: State = defaultState, action: Action) {
  switch (action.type) {
    case 'FETCH_PAGE_REQUEST':
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: {
            ...state.byUrl[action.url],
            state: 'FETCHING'
          }
        }
      };
    case 'FETCH_PAGE_SUCCESS': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: {
            ...state.byUrl[action.url],
            ...action.page,
            state: 'SUCCESS'
          }
        }
      };
    }
    case 'FETCH_PAGE_FAILURE': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: {
            ...state.byUrl[action.url],
            state: 'NOT_FOUND'
          }
        }
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
